import { get, create, getAll, update, deleteSurvey, getStats, getCommentList } from '../../services/survey.api'

const state = {
  items: [],
  stats: []
}

const getters = {
  surveys: (state) => {
    return state.items
  },
  getSurveyById: (state) => (id) => {
    return state.items.find(item => (item.id == id))
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id == id))
  },
  getByStatus: (state) => (status) => {
    if (status.length === 0 || status == 'all') {
      return state.items
    }
    return state.items.filter(survey => status == survey.status)
  },
  getStatsById: (state) => (id) => {
    return state.stats.find(item => (item.id == id))
  }
}

const actions = {
  async loadSurveys ({ commit, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    const surveys = await getAll(sitekey)
    commit('RESET_SURVEY_ITEMS')
    commit('ADD_SURVEY_ITEMS', { items: surveys })
    return surveys
  },

  async loadSurvey ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    const survey = await get(sitekey, id)
    commit('UPDATE_SURVEY_ITEM', { item: survey })
    return survey
  },

  resetSurveys ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('RESET_SURVEY_ITEMS')
      resolve()
    })
  },

  async addSurvey ({ commit, dispatch, rootGetters }, survey) {
    const sitekey = rootGetters['account/currentSitekey']

    const newSurvey = await create(sitekey, survey)
    commit('ADD_SURVEY_ITEM', { item: newSurvey })
    return newSurvey
  },

  async updateSurvey ({ commit, dispatch, rootGetters }, survey) {
    const sitekey = rootGetters['account/currentSitekey']

    const newSurvey = await update(sitekey, survey)
    commit('UPDATE_SURVEY_ITEM', { item: newSurvey })
    return newSurvey
  },

  async removeSurvey ({ commit, dispatch, rootGetters }, surveyToRemove) {
    const sitekey = rootGetters['account/currentSitekey']

    await deleteSurvey(sitekey, surveyToRemove)
    commit('REMOVE_SURVEY_ITEM', { item: surveyToRemove })
  },

  async getSurveyStats ({ commit, dispatch, rootGetters }, survey) {
    const sitekey = rootGetters['account/currentSitekey']

    const stats = await getStats(sitekey, survey)
    return stats
  },

  async loadSurveyStats ({ commit, dispatch, rootGetters }, {surveyId, startDate, endDate}) {
    const sitekey = rootGetters['account/currentSitekey']

    const stats = await getStats(sitekey, surveyId, startDate, endDate)
    commit('UPDATE_SURVEY_STATS', { stats: stats })
    return stats
  },

  async getCommentList ({ commit, dispatch, rootGetters }, {surveyId, page, limit, type}) {
    const sitekey = rootGetters['account/currentSitekey']

    const comments = await getCommentList(sitekey, surveyId, page, limit, type)
    return comments
  }
}

const mutations = {
  ADD_SURVEY_ITEMS (state, { items }) {
    state.items.push(...items)
  },

  ADD_SURVEY_ITEM (state, { item }) {
    state.items.push(item)
  },

  RESET_SURVEY_ITEMS (state) {
    state.items = []
  },

  UPDATE_SURVEY_ITEM (state, { item }) {
    let find = false

    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
        find = true
      }
    }

    if (!find) {
      state.items.push(item)
    }
  },

  REMOVE_SURVEY_ITEM (state, { item }) {
    let index = state.items.findIndex(i => i.id === item.id)
    if (index !== -1) {
      state.items.splice(index, 1)
    }
  },

  UPDATE_SURVEY_STATS (state, { stats }) {
    let find = false

    for (let i = 0; i < state.stats.length; i++) {
      if (state.stats[i].id === stats.id) {
        Object.assign(state.stats[i], stats)
        find = true
      }
    }

    if (!find) {
      state.stats.push(stats)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/surveys.js